import type { PharmacyGroup, UnattachedPharmacy } from './types';

import { apiClient } from '~shared/api';

export const createGroup = (values: unknown): Promise<unknown> =>
  apiClient.post<unknown>('/admin/valwin/groups', values, {
    groupId: 'valwin',
  });

export const getAllGroups = (): Promise<PharmacyGroup[]> =>
  apiClient.get<PharmacyGroup[]>('/admin/valwin/groups', { groupId: 'valwin' });

export const getAllGroupFeatures = (): Promise<unknown> =>
  apiClient.get<unknown>('/admin/valwin/groups/features', {
    groupId: 'valwin',
  });

export const getEnabledGroupFeatures = (
  pharmacyGroupId: string
): Promise<unknown> =>
  apiClient.get<unknown>(`/admin/valwin/groups/${pharmacyGroupId}/features`, {
    groupId: 'valwin',
  });

export const enableGroupFeature = (
  pharmacyGroupId: string,
  featureId: string
): Promise<unknown> =>
  apiClient.post<unknown>(
    `/admin/valwin/groups/${pharmacyGroupId}/features/${featureId}/enable`,
    null,
    { groupId: 'valwin' }
  );

export const disableGroupFeature = (
  pharmacyGroupId: string,
  featureId: string
): Promise<unknown> =>
  apiClient.post<unknown>(
    `/admin/valwin/groups/${pharmacyGroupId}/features/${featureId}/disable`,
    null,
    { groupId: 'valwin' }
  );

export const getGroupInfos = (pharmacyGroupId: string): Promise<unknown> =>
  apiClient.get<unknown>(`/admin/valwin/groups/${pharmacyGroupId}/infos`, {
    groupId: 'valwin',
  });

export const updateGroupInfos = (
  pharmacyGroupId: string,
  groupInfos: unknown
): Promise<unknown> =>
  apiClient.put<unknown>(
    `/admin/valwin/groups/${pharmacyGroupId}/infos`,
    groupInfos,
    { groupId: 'valwin' }
  );

export const getGroupFeed = (pharmacyGroupId: string): Promise<unknown> =>
  apiClient.get<unknown>(`/admin/valwin/groups/${pharmacyGroupId}/feed`, {
    groupId: 'valwin',
  });

export const updateGroupRssFeed = (
  pharmacyGroupId: string,
  url: string
): Promise<unknown> =>
  apiClient.put<unknown>(
    `/admin/valwin/groups/${pharmacyGroupId}/feed/rss`,
    { url },
    { groupId: 'valwin' }
  );

export const updateGroupScoopitFeed = (
  pharmacyGroupId: string,
  topic: string
): Promise<unknown> =>
  apiClient.put<unknown>(
    `/admin/valwin/groups/${pharmacyGroupId}/feed/scoopit`,
    { topic },
    { groupId: 'valwin' }
  );

export const deleteGroupFeed = (pharmacyGroupId: string): Promise<unknown> =>
  apiClient.delete<unknown>(`/admin/valwin/groups/${pharmacyGroupId}/feed`, {
    groupId: 'valwin',
  });

export const getGroupPharmacies = (
  pharmacyGroupId: string
): Promise<string[]> =>
  apiClient.get<string[]>(
    `/admin/valwin/groups/${pharmacyGroupId}/pharmacies`,
    { groupId: 'valwin' }
  );

export const getUnattachedPharmacies = (): Promise<UnattachedPharmacy[]> =>
  apiClient.get<UnattachedPharmacy[]>(
    '/admin/valwin/pharmacies?withGroup=false',
    { groupId: 'valwin' }
  );

export const attachPharmacies = (
  pharmacyGroupId: string,
  pharmacies: unknown
): Promise<unknown> =>
  apiClient.put<unknown>(
    `/admin/valwin/groups/${pharmacyGroupId}/pharmacies/attach`,
    pharmacies,
    { groupId: 'valwin' }
  );

export const configurePharmacies = (
  pharmacyGroupId: string,
  pharmacies: unknown
): Promise<unknown> =>
  apiClient.put<unknown>(
    `/admin/valwin/groups/${pharmacyGroupId}/pharmacies/configure`,
    pharmacies,
    { groupId: 'valwin' }
  );

export const detachPharmacies = (
  pharmacyGroupId: string,
  pharmacies: unknown
): Promise<unknown> =>
  apiClient.put<unknown>(
    `/admin/valwin/groups/${pharmacyGroupId}/pharmacies/detach`,
    pharmacies,
    { groupId: 'valwin' }
  );

export const getPharmacistWords = (pharmacyGroupId: string): Promise<unknown> =>
  apiClient.get<unknown>(
    `/admin/valwin/groups/${pharmacyGroupId}/pharmacist-words`,
    { groupId: 'valwin' }
  );

export const setPharmacistWord = (
  pharmacyGroupId: string,
  pw: unknown
): Promise<unknown> =>
  apiClient.post<unknown>(
    `/admin/valwin/groups/${pharmacyGroupId}/pharmacist-words`,
    pw,
    { groupId: 'valwin' }
  );

export const deletePharmacistWord = (
  pharmacyGroupId: string,
  pharmacyId: string
): Promise<unknown> =>
  apiClient.delete<unknown>(
    `/admin/valwin/groups/${pharmacyGroupId}/pharmacist-words/${pharmacyId}`,
    { groupId: 'valwin' }
  );
